import React from 'react'

export const PostActionsHeader = () => {
  return <label className="label post-admin-options__label">Options</label>
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/post_actions/postActionsHeader.view.js